//include 9
jQuery(function () {

    window.forDebugging = false;

    /**
     * the filters container
     * @type {jQuery|HTMLElement}
     */
    var filtersContainer = $(".rbnb-wrapper .search > .filters-container");
    /**
     * the search results container
     * @type {jQuery|HTMLElement}
     */
    var searchResultsContainer = $(".rbnb-wrapper .search-results .inner-wrapper");
    /**
     * the module wrapper
     * @type {jQuery|HTMLElement}
     */
    var wrapper = $(".rbnb-wrapper");
    /**
     * defines if it is an airbnb or external map
     * @type {boolean}
     */
    var isAirBnB = true;
    /**
     * the geojson data of the loaded list
     * @type {Array}
     */
    var geojsonData = [];

    /**
     * the url to get the filters from session
     * @type {string}
     */
    var sessionRequestUrl = window.pixelpoint.utilities.getAjaxUrl(`/index.php?action=sessionFilters&type=1732176051`);
    /**
     * the button to switch to list view and back to map view
     * @type {jQuery|HTMLElement}
     */
    var switchToMapButton = $(".brandenbutton.switch-to-map");
    /**
     * will be triggered after the map has loaded
     */
    var mapLoadedDefer = $.Deferred();
    /**
     * will be triggered after the session filters are loaded
     * @type {null}
     */
    var sessionFiltersDeferred = null;
    /**
     * the bounding box of the map
     * @type {null}
     */
    var boundingBox = null;
    /**
     * tells us if the map should be updated on the next movement or not
     * @type {boolean}
     */
    var supressMapUpdate = false;
    /**
     * the last used locations in the filter
     * @type {Array}
     */
    var lastUsedLocations = [];

    /**
     * ZP 08.09.2022 - this variable will be set to true after a direct user interaction with the map
     * when set to true, the boundingbox will be again used. Otherwise all searhes (except for soft search)
     * will be made without bounding box
     */
    var lockedAfterUserInteraction = false;

    /**
     * the dce id
     */
    var cid = wrapper.data("cid");
    /**
     * the page id
     */
    var pid = wrapper.data("pid");
    /**
     * tells us if the initial request was a GET or POST request. If it was a POST the results will not be reloaded
     */
    var requestType = wrapper.data('request');
    /**
     * tells us if the DCE is an AirBnB or external map
     * @type {boolean}
     */
    var isAirBnbOrExternalMap = false;

    // if we did not find airBnB specific containers, this might be an external map
    if (filtersContainer.length == 0 || searchResultsContainer.length == 0) {
        return; // we have a separate js for the external map now
    }

    /**
     * we have an AirBnB
     */
    if ($("#rbnb-wrapper-id").length || $("#external-map-wrapper-id").length) {
        isAirBnbOrExternalMap = true;
        initStickyAirBnBelements();
    }
    /**
     * we have the search site
     */
    else if ($("#search-wrapper-id").length) {
    } else {
    }
    /**
     * the form element
     */
    var form = filtersContainer.find("form");
    /**
     * the loader
     */
    var loaderFunctions = wrapper.find(".search-results .loader[data-loader]").data("exposed");

    //deferred objects and simmilar-
    /**
     * the Ajax Request Deferred object
     * @type {null}
     */
    var ajaxRequest = null;
    /**
     * the deferred that signalises when the map stopped moving
     * @type {null}
     */
    var moveEndTimeout = null;
    //------------------------------
    /**
     * ignoring all airbnb events
     * @type {boolean}
     */
    var ignoreAirBnBEvent = true;
    /**
     * tells us if we change the map section on new data load or not
     * @type {boolean}
     */
    var changeMapSection = false;
    /**
     * tells us if we move to the AirBnB DCE after a new search or not
     * @type {boolean}
     */
    var supressSliding = true;

    //*************** a few helper functions to manipulate the form *****************************/
    window.pixelpoint = window.pixelpoint || {};
    window.pixelpoint.searchform = {
        /**
         * shows or hides the tour length slider element
         */
        showHideTourLength() {
            if ($(".tour-length-input").length > 0) {
                if ($(".showontour").length > 0) {
                    $(".showontour").removeClass("hide");
                    $(".showontour").each((index, element) => {
                        $(element).removeClass("hide");
                        var eventsPostfix = $(element).find(".range-slider").data("events-postfix");

                        var sliderEnableEvent = `${window.pixelpoint.pubSub.events.slidersEventEnable}:${eventsPostfix}`,
                            sliderDisableEvent = `${window.pixelpoint.pubSub.events.slidersEventDisable}:${eventsPostfix}`,
                            sliderChangeEvent = `${window.pixelpoint.pubSub.events.slidersEventChange}:${eventsPostfix}`;

                        var sliderValueElement = $(element).find(".range-slider input[type='hidden']");
                        if (sliderValueElement.length > 0 && !sliderValueElement.is(":disabled") && sliderValueElement.val() != "0,0") {
                            $(".tour-length-input").val(sliderValueElement.val());
                            $(".tour-length-input").prop("disabled", false);
                        }


                        window.pixelpoint.pubSub
                            .unsubscribe(sliderEnableEvent)
                            .unsubscribe(sliderDisableEvent)
                            .unsubscribe(sliderChangeEvent)
                            .subscribe(sliderEnableEvent, function (e) {
                                $(".tour-length-input").prop("disabled", false);
                            })
                            .subscribe(sliderDisableEvent, function (e) {
                                $(".tour-length-input").prop("disabled", true);
                            })
                            .subscribe(sliderChangeEvent, function (e, value) {
                                $(".tour-length-input").val(value);
                                if (value != '0,0') {
                                    $(".tour-length-input").prop("disabled", false);
                                } else {
                                    $(".tour-length-input").prop("disabled", true);
                                }
                            });
                    });
                }
            } else {
                $(".showontour").addClass("hide");
            }
        }
    }
    //***************************************************************************************** */

    /**
     * map functions
     * @type {{mapObject(): *, getMapType(): (string), removeBBox(): void, isSearchOnMoveActive(): *, isSearchSupressed(): *}}
     */
    var mapFunctions = {
        /**
         * gets the AirBnB map object
         */
        mapObject() {
            var airBnB = null;

            if (typeof ppcartoAirbnb != "undefined" && !!ppcartoAirbnb && !!ppcartoAirbnb.$refs && !!ppcartoAirbnb.$refs.airbnb) {
                airBnB = ppcartoAirbnb.$refs.airbnb;
            } else if (typeof ppcartoStatic != "undefined" && !!ppcartoStatic && !!ppcartoStatic.$refs && !!ppcartoStatic.$refs.static) {
                airBnB = ppcartoStatic.$refs.static;
            }

            return airBnB;
        },
        /**
         * gets the map type, airbnb, static or undefined if the type could not be determined
         */
        getMapType() {
            if (typeof ppcartoAirbnb != "undefined" && !!ppcartoAirbnb && !!ppcartoAirbnb.$refs && !!ppcartoAirbnb.$refs.airbnb) {
                return "airbnb";
            } else if (typeof ppcartoStatic != "undefined" && !!ppcartoStatic && !!ppcartoStatic.$refs && !!ppcartoStatic.$refs.static) {
                return "static";
            }

            return "undefined";
        },
        /**
         * removes the bbox from the filters saved in the airbnb object
         */
        removeBBox() {
            var mapObject = mapFunctions.mapObject();
            if (!!mapObject.filter && !!mapObject.filter.bbox) {
                delete mapObject.filter.bbox;
            }
        },
        /**
         * do we make a new search when the map moves or not
         */
        isSearchOnMoveActive() {
            var mapObject = mapFunctions.mapObject();
            return mapObject.triggerSearchOnMove || false;
        },
        /**
         * tells us if the search is supressed or not
         */
        isSearchSupressed() {
            var mapObject = mapFunctions.mapObject();
            return mapObject.supressSearch || false;
        },
        changeBBox(bbox, convertToArray) {
            if (!bbox)
                return bbox;
            let splittedBox = null;
            if (_.isString(bbox))
                splittedBox = bbox.split(",");
            else if (
                _.isArray(bbox) &&
                !!bbox[0] &&
                !!bbox[0][0] &&
                !!bbox[0][1] &&
                !!bbox[1] &&
                !!bbox[1][0] &&
                !!bbox[1][1]
            ) {
                splittedBox = _.flatten(bbox);
            }
            if (splittedBox != null && splittedBox.length >= 4) {

                if (parseFloat(splittedBox[0]) > parseFloat(splittedBox[1])) {
                    let tmp = splittedBox[0];
                    splittedBox[0] = splittedBox[1];
                    splittedBox[1] = tmp;
                }
                if (parseFloat(splittedBox[2]) > parseFloat(splittedBox[3])) {
                    let tmp = splittedBox[2];
                    splittedBox[2] = splittedBox[3];
                    splittedBox[3] = tmp;
                }
                // we switch the 2nd and 4th coordinate
                if (parseFloat(splittedBox[1]) > parseFloat(splittedBox[3])) {
                    let tmp = splittedBox[1];
                    splittedBox[1] = splittedBox[3];
                    splittedBox[3] = tmp;
                }
                //end
                if (convertToArray) {
                    bbox = [[splittedBox[0], splittedBox[1]], [splittedBox[2], splittedBox[3]]];
                } else {
                    bbox = splittedBox.join(",");
                }
            }
            return bbox;
        },
        getBBox() {
            var mapObject = mapFunctions.mapObject();
            let bbox = '0,0,0,0';
            if (mapObject && mapObject.bbox) {
                bbox = mapObject.bbox();
                bbox = mapFunctions.changeBBox(bbox);
            }
            return bbox;
        }
    };
//********************************************************************************************
    /**
     * private functions
     * ***************************************************************************************
     * ***************************************************************************************
     */
    var privateFunctions = {
        removePageParameter(url) {
            if (!url)
                return url;
            let parsedUrl = window.pixelpoint.utilities.parseUrl(url);
            if (parsedUrl.queryParameters.hasOwnProperty('page'))
                delete parsedUrl.queryParameters.page;
            return window.pixelpoint.utilities.buildUrl(parsedUrl);
        },
        collectPoiData($html = null) {
            geojsonData = [];
            var $elements = null;
            if ($html == null) {
                $elements = wrapper.find("[data-geojson]");
            } else {
                $elements = $html.find("[data-geojson]");
            }
            $elements.each(function () {
                var geojson = $(this).data('geojson');
                if (!!geojson) {
                    geojsonData.push(geojson);
                }
            });
        },
        populateMissingElements() {
            //*
            if ($("ul.result-pagination").length > 0) {
                wrapper.closest(".search-wrapper").find(".rbnb-pagination-wrapper").each(function () {
                    $(this).html('').append($("ul.result-pagination").first().clone());
                });
            }
            //*/
            if ($(".result-count").length > 0) {
                $(".rbnb-count-wrapper").each(function () {
                    $(this).html($(".result-count").html());
                });
            } else {
                $(".rbnb-count-wrapper").each(function () {
                    $(this).html("");
                });
            }

            if ($(".group-names-container li").length > 0) {

                $(".rbnb-categories-wrapper").off("click").on("click", "li.group-category", function (e) {
                    var icon = $(e.target).closest("li.group-category");
                    var groupId = icon.data("group-icon");
                    if (!!groupId) {
                        var group = $(`li[data-group-id='${groupId}']`);
                        if (group.length > 0) {
                            var groupContainer = group.closest(".group-names-container");
                            if (groupContainer.length > 0) {
                                if (groupContainer.hasClass("collapsed")) {
                                    var collapseId = groupContainer.data("id");
                                    $(`[data-target='${collapseId}']`).click();
                                }
                                var scrollPosition = (groupContainer.offset().top - privateFunctions.getHeaderHeight()) - 10;
                                scrollPosition = privateFunctions.getRealScrollPosition(scrollPosition);
                                $('html,body').animate({
                                    scrollTop: scrollPosition
                                }, 500);
                            }
                        }
                    }
                });

                $(".rbnb-categories-wrapper").each(function () {
                    var $this = $(this);
                    var numberOfCategories = $(".group-names-container li").length;
                    if (numberOfCategories <= 4) {
                        $this.addClass("with-" + numberOfCategories + "-icons");
                    } else {
                        $this.addClass("with-more-icons");
                    }

                    var ul = $('<ul></ul>');
                    $this.html('').append(ul);

                    $(".group-names-container li").each(function (index) {
                        if (numberOfCategories > 4) {
                            var externalId = null;
                            var group = null;
                            if (index < 1 || index > (numberOfCategories - 2)) {
                                externalId = $(this).data("external-id");
                                group = $(this).data("group-id");
                                if (!!externalId) {
                                    ul.append(`<li class="group-category" data-group-icon="${group}"><i class="bb-icon-${externalId} ttip-blue tooltipstered"></i></li>`);
                                }
                            } else if ($this.find(".three-dots").length == 0) {
                                ul.append('<li class="three-dots">...</li>');
                            }
                        } else {
                            externalId = $(this).data("external-id");
                            group = $(this).data("group-id");
                            if (!!externalId) {
                                ul.append(`<li class="group-category" data-group-icon="${group}"><i class="bb-icon-${externalId} ttip-blue tooltipstered"></i></li>`);
                            }
                        }
                    });
                });
            }
        },
        switchToDefaultView() {
            if (switchToMapButton.length == 0)
                return;
            var id = switchToMapButton.data('switch-trigger');
            if (!id)
                return;
            window.pixelpoint.pubSub.publish(window.pixelpoint.pubSub.events.switchSetDefault + ":" + id);
        },
        addBBox(data, bbox) {
            if (!bbox)
                return data;
            if (!bbox[0] || !bbox[0][0] || !bbox[0][1] || !bbox[1] || !bbox[1][0] || !bbox[1][1])
                return data; //bbox malformed
            bbox = mapFunctions.changeBBox(bbox, true);
            for (var i = 0; i < 2; i++) {
                for (var j = 0; j < 2; j++) {
                    var obj = {
                        'name': `filters[bbox][${i}][${j}]`,
                        'value': bbox[i][j]
                    }
                    data.push(obj);
                }
            }
            return data;
        },
        loadSessionFilters() {
            if (!sessionFiltersDeferred) {
                sessionFiltersDeferred = $.Deferred(function (defer) {
                    $.ajax(sessionRequestUrl, {
                        method: "POST",
                        data: JSON.stringify({
                            keys: ['AirBnB', cid],
                            url: window.location.href
                        }),
                        contentType: "application/json; charset=utf-8"
                    }).done(function (data, textStatus, request) {
                        defer.resolve(data);
                    }).fail(defer.reject).always(defer.always);
                }).promise();
            }
        },
        getHeaderHeight() {
            return $(".header-wrapper .header").outerHeight();
        },
        getRealWindowHeight() {
            return $(window).height() - privateFunctions.getHeaderHeight();
        },
        getRealScrollPosition(scrollPosition) {
            var bottomModulePosition = wrapper.offset().top + wrapper.height();
            if ((bottomModulePosition - scrollPosition) < privateFunctions.getRealWindowHeight()) {
                return bottomModulePosition - $(window).height();
            }
            return scrollPosition;
        },
        clearDefaultTextValue() {
            //clears the default text value. Since the preset text value must not be visible, we have to set it each time. This function
            //the default text value. It is called on clicko on the button
            var input = wrapper.find("input[name='filters[q]']");
            if (!input.data('saved-default-value'))
                input.data('saved-default-value', input.data('default-value'));
            input.data('default-value', '');
        },
        restoreDefaultValue() {
            var input = wrapper.find("input[name='filters[q]']");
            if (!!input.data('saved-default-value'))
                input.data('default-value', input.data('saved-default-value'));
        },
        setDefaultValue(data) {
            //sets the default value since we need to use it in some cases (if the map moves for example)
            var defaultValue = wrapper.find("input[name='filters[q]']").data('default-value');
            if (!!defaultValue) {
                $.each(data, function (index, element) {
                    if (element.name == "filters[q]") {
                        element.value = defaultValue
                    }
                });
            }
            return data;
        },
        moveToElement(data) {
            var id = data.id || 0;
            if (!id) {
                return;
            }

            var searchResultItem = $(`.search-result-item[data-id='${id}']`);

            if (searchResultItem.length == 0) {
                return searchResultItem;
            }

            var headerHeight = $(".header-wrapper .header").height() || 0;
            var offset = searchResultItem.offset();
            var topOffset = offset.top;
            var bottomOffset = offset.top + searchResultItem.height();

            if (topOffset < ($(window).scrollTop() + headerHeight) || bottomOffset > ($(window).scrollTop() + $(window).height())) {
                // Not in view so scroll to it
                var scrollPosition = (topOffset - headerHeight) - 10;
                scrollPosition = privateFunctions.getRealScrollPosition(scrollPosition);
                $('html,body').animate({
                    scrollTop: scrollPosition
                }, 500);
            }

            return searchResultItem;
        },
        afterAllImagesLoaded($container) {
            var d = $.Deferred();
            var imgs = $container.find("img");
            imgs.one("load.allimages error.allimages", function () {
                imgs = imgs.not(this);
                if (imgs.length == 0) {
                    d.resolve();
                }
            });
            var complete = imgs.filter(function () {
                return this.complete;
            });
            complete.off(".allimages");
            imgs = imgs.not(complete);
            complete = undefined;
            if (imgs.length == 0) {
                d.resolve();
            }
            return d.promise();
        },
        setResultItemHeight() {
            var equalHeighElem = $("#search-wrapper-id .search-result-item");
            setTimeout(function () {
                equalHeight(equalHeighElem, true);
                initStickyAirBnBelements();
                $('.map-wrapper.sticky').foundation('_calc', true);
            }, 100);
        },
        validateForm(displayErrors) {
            displayErrors = displayErrors || false;
            form.find(".invalid").removeClass("invalid");
            var valid = true;

            var visitorPicker = form.find(".visitor-picker");
            var distancePicker = form.find(".distance-picker");
            if (visitorPicker.length > 0) {
                var formFunctions = visitorPicker.data("form-element-functions");
                if (!!formFunctions.get) {
                    var visitors = formFunctions.get();
                    if (!!visitors.kids && visitors.kids > 0) {
                        if (visitorPicker.is("[data-to-disable]")) {
                            var von = form.find(".calendar input.von").val();
                            var bis = form.find(".calendar input.bis").val();
                            if (!von || !bis) {
                                valid = false;
                                if (displayErrors) {
                                    form.find(".calendar").closest(".element-wrapper").addClass("invalid");
                                }
                            }
                        }
                    }
                }
                if (!!formFunctions.valid) {
                    if (!formFunctions.valid(true)) {
                        valid = false;
                    }
                }
            }
            if (distancePicker.length > 0) {
                var distanceFormFunctions = distancePicker.data("form-element-functions");
                if (!!distanceFormFunctions.valid) {
                    if (!distanceFormFunctions.valid(true)) {
                        valid = false;
                    }
                }
            }
            return valid;
        },
        generateFormAction(url, bbox, switchValue) {
            if (!cid || !pid) {
                return url;
            }
            bbox = bbox || null;
            switchValue = switchValue || null;

            var domainReloadParameters = window.pixelpoint.utilities.getSysPageUrl();
            var parsed = window.pixelpoint.utilities.parseUrl(url);
            parsed.baseUrl = domainReloadParameters.baseUrl;//window.location.origin;
            if (domainReloadParameters.useAjaxRenderPageId)
                parsed.queryParameters.id = domainReloadParameters.ajaxRenderPageId;
            //parsed.queryParameters.id = window.pixelpoint.domainService.get("ajaxRenderPage");//1568;
            parsed.queryParameters.cid = cid;
            parsed.queryParameters.pid = pid;
            parsed.queryParameters.no_cache = 1;

            if ($("a.search-in-area").length > 0 && $(".locationTree").parent().find(".select2 .select2-selection__choice").length > 0) {
                parsed.queryParameters.searchingInArea = 1;
            }

            if (!!switchValue) {
                parsed.queryParameters.switchValue = switchValue;
            } else {
                if ($('[name="switchValue"]').length > 0) {
                    parsed.queryParameters.switchValue = $('[name="switchValue"]').val();
                } else {
                    // the hidden switchValue field only gets created once the switch is triggered
                    // Before that we fall back to the switch button's initial/selected value so the very first reload already carries it.
                    var initialSwitchValue = $(".show-map-wrapper .switch-to-map").data('selected-value') || $(".show-map-wrapper .switch-to-map").data('initial-value');
                    if (!!initialSwitchValue) {
                        parsed.queryParameters.switchValue = initialSwitchValue;
                    }
                }
            }

            if (!!parsed.queryParameters.cHash) {
                delete parsed.queryParameters.cHash;
            }

            if (!!bbox) {
                if ($.isArray(bbox))
                    bbox = bbox.join();
                parsed.queryParameters.bbox = bbox;
            }

            return window.pixelpoint.utilities.buildUrl(parsed);
        },

        /**
         * **************************************************************************
         * **************************************************************************
         */

        makeSearch(url, method, parameters) {
            var finished = $.Deferred();

            parameters = parameters || "";
            ajaxRequest = $.ajax({
                type: method,
                url: url,
                data: parameters,
                success: function (data) {
                    var $data = $(data);
                    privateFunctions.collectPoiData($data);
                    finished.resolve({
                        raw: data,
                        obj: $data
                    });
                }
            });
            return finished.promise();
        },


        /**
         * **************************************************************************
         * **************************************************************************
         */
// isMapUserInteractionEvent - tells us if the search was triggered by a user initiated map move event
        submitForm(callback, isMapUserInteractionEvent, softSearchEnabled) {
            console.log(
              isMapUserInteractionEvent ? "%cSearch was triggered by map user interaction" : "%c Search not triggered by map",
                "color: red; background: green;"
            );

            if (form.length == 0) return;
            var url = form.attr('action');
            if (!url) {
                url = window.location.href;
            }
            var switchToMap = $(".show-map-wrapper .switch-to-map");
            if (switchToMap.length > 0) {
                var currentValue = switchToMap.data('selected-value') || switchToMap.data('initial-value');
                url = privateFunctions.generateFormAction(url, null, currentValue);
            } else {
                url = privateFunctions.generateFormAction(url);
            }

            var method = form.attr('method');
            if (!!loaderFunctions) {
                loaderFunctions.show();
            }

            var bbox = boundingBox;
            var selectedRegionId = null;
            var selectedRegionType = "";

            privateFunctions.clearRegionFromAirBnB();

            var data = form.serializeArray();
            $.each(data, function (index, element) {
                // we get the first selected region (if there is any)
                if (selectedRegionId == null) {
                    if (element.name == 'filters[locationTree][]') {
                        if (element.value.indexOf(":region") > -1) {
                            let splitted = element.value.split(":");
                            selectedRegionId = splitted[0];
                            selectedRegionType = 'region';
                        } else if (element.value.indexOf(":aqua") > -1) {
                            let splitted = element.value.split(":");
                            selectedRegionId = splitted[0];
                            selectedRegionType = 'aquaticsdistrict';
                        } else if (element.value.indexOf(":national") > -1) {
                            let splitted = element.value.split(":");
                            selectedRegionId = splitted[0];
                            selectedRegionType = 'nationallandscape';
                        } else if (element.value.indexOf(":excursion") > -1) {
                            let splitted = element.value.split(":");
                            selectedRegionId = splitted[0];
                            selectedRegionType = 'excursion';
                        }
                    }
                }
                if (element.name == 'filters[q]') {
                    if (!element.value) {
                        var defaultData = $(`[name='filters[q]']`).data('default-value');
                        if (!!defaultData)
                            element.value = defaultData;
                    }
                }
            });

            //set the default value, if it exists
            data = privateFunctions.setDefaultValue(data);

            /*
            * if active user inteaction, we activate the bounding box again and
            * use it until we got a location search (location, region, district)
            * */

            //ZP 02-09-2022 it is checked based on the map move event:
            //             if the search was a consequence of the mapmove event and the event was user interaction triggered we add the bounding box,
            //             otherwise not
            // also, we keep track of whether softsearch is enabled or not. Softsearch still requires a boundingbox
            if(isMapUserInteractionEvent){
                lockedAfterUserInteraction = true;
            }
            if(lockedAfterUserInteraction || softSearchEnabled){
                //add the geojson data, if existing
                if (!!bbox && $.isArray(bbox)) {
                    data = privateFunctions.addBBox(data, bbox);
                } else if (!!bbox && $.type(bbox) === "string") {
                    data.push({
                        name: "filters[bbox]",
                        value: bbox
                    })
                }
            }
            else{
                data = data.filter(x => x.name !== "filters[bbox]");
            }

            if (!!ajaxRequest) {
                ajaxRequest.abort();
            }
            form.find(".groups").hide();

            //***************************
            privateFunctions.makeSearch(url, method, data).then(function (data) {
                var results = data.obj.find(".search-results .inner-wrapper").html();
                if (!results) results = '';
                searchResultsContainer.html(results);
                window.pixelpoint.debug.writeFromData('json-filters', 'The json filters');
                window.pixelpoint.images.initializeErrors(searchResultsContainer);
                privateFunctions.populateMissingElements();

                //privateFunctions.initializeSliders();
                window.pixelpoint.tooltip.init(searchResultsContainer.find('.ttip-blue'));
                window.pixelpoint.initOpeningHoursText();

                $('.map-wrapper.sticky').foundation('_calc', true);

                if (!!loaderFunctions) {
                    privateFunctions.afterAllImagesLoaded(searchResultsContainer).then(function () {
                        privateFunctions.setResultItemHeight();
                        loaderFunctions.hide();
                    });
                }

                var itemCount = $(".result-list .search-result-item").length;
                if (!supressSliding) {
                    if (itemCount > 0) {
                        let scrollPosition = $(".search-results").offset().top - $(".header-wrapper .header").height();
                        scrollPosition = privateFunctions.getRealScrollPosition(scrollPosition);
                        $('html, body').animate({
                            scrollTop: scrollPosition
                        }, 500);
                    } else {
                        let scrollPosition = $(".filters-container").offset().top - $(".header-wrapper .header").height();
                        scrollPosition = privateFunctions.getRealScrollPosition(scrollPosition);
                        $('html, body').animate({
                            scrollTop: scrollPosition
                        }, 500);
                    }
                    supressSliding = true;
                }
                //ZP 21.05.2020: not sure if we still need the "ignoreAirBnB" variable

                if (!supressMapUpdate && !!isAirBnB) {
                    ignoreAirBnBEvent = true;

                    //because sometimes the map does not trigger the event after moving (have to find out the reason yet),
                    //we have to make sure, the "ignoreAirBnBEvent" variable is set to false after a period of time
                    setTimeout(function () {
                        ignoreAirBnBEvent = false;
                    }, 2000);
                } else {
                    supressMapUpdate = false;
                }
                if (selectedRegionId != null) {
                    changeMapSection = true;
                }

                privateFunctions.calculateOffset();
                privateFunctions.dataToAirBnB();

                if (selectedRegionId != null) {
                    privateFunctions.regionToAirBnB(selectedRegionId, selectedRegionType);
                }
                privateFunctions.checkDistanceOrdering();
                ajaxRequest = null;

                // do everything for mobile
                if (isAirBnbOrExternalMap && $('#airbnb-buttons').is(':visible')) {
                    followingEementInContainer($('#airbnb-buttons'), $('#search-results-for-sticky-buttons'));
                }
                if (!!callback)
                    callback();
            });
        },
        clearRegionFromAirBnB() {
            var airBnB = mapFunctions.mapObject();
            if (!airBnB || !airBnB.clearRegion)
                return;
            airBnB.clearRegion();
        },
        regionToAirBnB(id, type) {
            if (!id)
                return;
            type = type || 'region';
            var airBnB = mapFunctions.mapObject();
            if (!airBnB)
                return;
            airBnB.setRegion({
                type: type,
                id: window.pixelpoint.utilities.getMapRegion(id)//id
            });
        },
        //ZP 18.05.2020 TPBB-1069: the customer wants the bounding box for all found pois,
        // not just those on the first page
        wholeBoundingBoxToAirBnB(bboxString) {
            let airBnB = mapFunctions.mapObject();
            if (!airBnB)
                return;
            airBnB.setAdditionalBoundingBox(bboxString);
        },
        wholeBoundingBoxClear() {
            let airBnB = mapFunctions.mapObject();
            if (!airBnB)
                return;
            airBnB.setAdditionalBoundingBox(null);
        },
        //end
        checkDistanceOrdering() {
            var resultListWrapper = searchResultsContainer.find(".result-list-wrapper");
            if (resultListWrapper.length > 0) {
                var filters = resultListWrapper.data("jsonFilters");
                if (!!filters && !!filters.location) {
                    $(".order-distance").removeClass("hide");
                    $(".orderby-wrapper").addClass("with-distance-filter");
                    return;
                }
            }
            $(".order-distance").addClass("hide");
            $(".orderby-wrapper").removeClass("with-distance-filter");
            if ($("hidden.filters_order").length > 0 && $("hidden.filters_order").val() == "distance") {
                $("hidden.filters_order").val("");
            }
        },
        dataToAirBnB() {
            var airBnB = mapFunctions.mapObject();
            if (!airBnB)
                return;
            var type = searchResultsContainer.find(".result-list-wrapper").data("jsonEndpoint");
            if (!type)
                type = "poi";
            if (!!changeMapSection) {
                airBnB.init = true;
                airBnB.zoom = null;
                airBnB.coordinates = [];
                changeMapSection = false;
            }

            //ZP 18.05.2020 TPBB-1069: the customer wants the bounding box for all found pois,
            // not just those on the first page
            let bboxString = searchResultsContainer.find(".result-list-wrapper").data('whole-boundingbox');

            if (!!bboxString) {
                privateFunctions.wholeBoundingBoxToAirBnB(bboxString);
            } else {
                privateFunctions.wholeBoundingBoxClear();
            }

            airBnB.type = type;
            airBnB.geojson = {
                "type": "FeatureCollection",
                "features": geojsonData
            };
        },
        calculateOffset() {
            var airBnB = mapFunctions.mapObject();
            if (!airBnB)
                return;
            if (!$(".rbnb-wrapper").is(".fullsize")) {
                airBnB.offset = 0;
                return;
            }
            if ($('#airbnb-buttons').is(':visible')) {
                airBnB.offset = 0;
                return;
            }
            var searchContainer = $(".rbnb-wrapper .search");
            if (searchContainer.length == 0)
                return;
            var offset = searchContainer.offset().left + searchContainer.outerWidth();
            if (searchContainer.hasClass("switch-big")) {
                offset = offset / 2;
            }
            airBnB.offset = offset;
        },
        initialSetBBox() {
            var mapWrapper = $(".map-internal-wrapper");

            privateFunctions.calculateOffset();

            var zoom = mapWrapper.data("initial-zoom");
            var longitude = mapWrapper.data("initial-longitude");
            var latitude = mapWrapper.data("initial-latitude");

            var reloadModule = function () {
                if (!!isAirBnB) {
                    //privateFunctions.filtersToAirBnB(); //@deprecated
                    if (requestType == 'GET' || requestType == 'HEAD') {
                        supressMapUpdate = false;
                        privateFunctions.reloadModule();
                    } else {
                        privateFunctions.submitForm();
                    }
                } else {
                    privateFunctions.reloadModule();
                }
            }

            if (zoom > 0 || (zoom > 0 && longitude > 0 && latitude > 0)) {
                sessionFiltersDeferred.done(function (data) {
                    if (!data) {
                        //-----------------------------------
                        var viewArguments = {animate: false};
                        if (zoom > 0)
                            viewArguments.zoom = zoom;
                        if (longitude > 0 && latitude > 0)
                            viewArguments.coordinates = [longitude, latitude];
                        if (!!isAirBnB) {
                            mapFunctions.mapObject().$once("moveend", function (data) {
                                var bbox = mapFunctions.getBBox();//mapFunctions.mapObject().bbox();
                                boundingBox = bbox;
                                supressMapUpdate = true;
                                if (requestType == 'POST') {
                                    privateFunctions.submitForm();
                                } else {
                                    supressMapUpdate = false;
                                    //ZP 02.09.2022 - we do not want to use the boundingbox if the event was trigerred programatically
                                    !!data.isUserInteractionEvent ?
                                        privateFunctions.reloadModule(bbox, null, true) :
                                        privateFunctions.reloadModule(null, null, true);
                                }
                                // ZP 18.05.2020 - TPBB-1069(not part of ticket, problem was just referenced here):
                                // if map was moved we can not move the map again when we send the results to the map
                                mapFunctions.mapObject().fixMapPosition = true;
                            });
                        }
                        if (!!isAirBnB) {
                            mapFunctions.mapObject().$nextTick(function () {
                                mapFunctions.mapObject().init = false;
                                mapFunctions.mapObject().changeView(viewArguments);
                            });

                            mapFunctions.mapObject().fixMapPosition = true;
                            privateFunctions.submitForm(null, true, false);
                            
                        } else {
                            reloadModule();
                        }
                        //-----------------------------------
                    } else {
                        reloadModule();
                    }
                });
            } else {
                reloadModule();
            }
        },
        switchFilters(filtersHtml) {
            if (!filtersHtml)
                return;
            if (!filtersContainer || filtersContainer.length == 0)
                return;
            var filterForm = filtersContainer.find('.filter-form');
            filterForm.html("");
            filterForm.append($(filtersHtml));

            filterForm.find(".calendar").each(function () {
                window.pixelpoint.ppComponents.calendar($(this));
            });
            filterForm.find(".visitor-picker").each(function () {
                window.pixelpoint.ppComponents.visitorPicker($(this));
            });
            filterForm.find(".distance-picker").each(function () {
                window.pixelpoint.ppComponents.distancePicker($(this));
            });
            filterForm.find("[data-quick-clear]").each(function () {
                window.pixelpoint.ppComponents.quickClear($(this));
            });
            filterForm.find(".belegung-component").each(function () {
                window.pixelpoint.ppComponents.belegung($(this));
            });
            filterForm.find("[data-disabler]").each(function () {
                window.pixelpoint.ppComponents.disabler($(this));
            });

            var marginInPx = $('.header-wrapper .header').height();

            // scroll effect on Large Screens
            if (Foundation.MediaQuery.current == "large") {
                //var marginInPxNew = $('.header-wrapper .header .main-nav').height() + 12;
                var marginInPxNew = $('.header-wrapper .header .main-nav').height() - 2;
                marginInPx = marginInPxNew;
            }
            // scroll effect on Large Screens - END

            var marginInEm = marginInPx / parseFloat($("body").css("font-size"));

            if (filterForm.find("[data-order-by]").length > 0) {
                setTimeout(function () {
                    var sticky = new Foundation.Sticky(filterForm.find("[data-order-by]"), {
                        topAnchor: 'orderbywrapper:top',
                        btmAnchor: 'rbnb-wrapper-id:bottom',
                        marginTop: marginInEm
                    });
                    $(window).trigger("load.zf.sticky");
                }, 50);
                filterForm.find("[data-order-by]").each(function () {
                    window.pixelpoint.ppComponents.orderBy($(this));
                });
            } else {
                if (filterForm.find(".order-by").length > 0) {
                    setTimeout(function () {
                        var sticky = new Foundation.Sticky(filterForm.find(".order-by"), {
                            topAnchor: 'orderbywrapper:top',
                            btmAnchor: 'rbnb-wrapper-id:bottom',
                            marginTop: marginInEm
                        });
                        $(window).trigger("load.zf.sticky");
                    }, 50);
                }
            }
            window.ppComponents.common.sliders(filterForm.find(".range-slider"));
            window.ppComponents.select2.initialize(filterForm.find('.select2'));
            window.ppComponents.select2.initializeRemote(filterForm.find("select.autocomplete"));

            filterForm.find("[data-group-selector]").each(function () {
                window.pixelpoint.ppComponents.groupExtension($(this));
            });
            filterForm.find(".loader[data-loader]").each(function () {
                window.pixelpoint.ppComponents.loader($(this));
            });
            window.ppComponents.common.showMore(filterForm.find(".more-wrapper"));
            privateFunctions.checkAndHideExpandButton();

            window.pixelpoint.searchform.showHideTourLength();
        },
        reloadModule(boundingBox, callback, keepMapSection, switchValue) {
            switchValue = switchValue || null;
            var url = privateFunctions.generateFormAction(window.location.href, boundingBox, switchValue);
            keepMapSection = keepMapSection || false;
            if (!!loaderFunctions) {
                loaderFunctions.show();
            }

            privateFunctions.makeSearch(url, 'GET').then(function (data) {
                var results = data.obj.find(".search-results .inner-wrapper").html();
                var filtersHtml = $(data).find(".search > .filters-container .filter-form").html();
                if (!results) results = '';
                searchResultsContainer.html(results);
                window.pixelpoint.debug.writeFromData('json-filters', 'The json filters');

                window.pixelpoint.images.initializeErrors(searchResultsContainer);

                if (!!isAirBnB) {
                    if (!filtersHtml)
                        filtersHtml = '';
                    privateFunctions.switchFilters(filtersHtml);
                }

                privateFunctions.populateMissingElements();

                //privateFunctions.initializeSliders();
                window.pixelpoint.tooltip.init(searchResultsContainer.find('.ttip-blue'));
                window.pixelpoint.initOpeningHoursText();
                $('.map-wrapper.sticky').foundation('_calc', true);
                if (!!loaderFunctions) {
                    privateFunctions.afterAllImagesLoaded(searchResultsContainer).then(function () {
                        privateFunctions.setResultItemHeight();
                        loaderFunctions.hide();
                    });
                }
                var itemCount = $(".result-list .search-result-item").length;
                /*
                if (!supressSliding) {
                    if (itemCount > 0) {
                        let scrollPosition = $(".search-results").offset().top - $(".header-wrapper .header").height();
                        scrollPosition = privateFunctions.getRealScrollPosition(scrollPosition);
                        $('html, body').animate({
                            scrollTop: scrollPosition
                        }, 500);
                    } else {
                        let scrollPosition = $(".filters-container").offset().top - $(".header-wrapper .header").height();
                        scrollPosition = privateFunctions.getRealScrollPosition(scrollPosition);
                        $('html, body').animate({
                            scrollTop: scrollPosition
                        }, 500);
                    }
                } else {
                    supressSliding = false;
                }
                //*/

                if (!supressMapUpdate && !!isAirBnB) {
                    ignoreAirBnBEvent = true;

                    if (!keepMapSection)
                        changeMapSection = true; // if reloading the module, we always change the map section

                    //because sometimes the map does not trigger the event after moving (have to find out the reason yet),
                    //we have to make sure, the "ignoreAirBnBEvent" variable is set to false after a period of time
                    setTimeout(function () {
                        ignoreAirBnBEvent = false;
                    }, 2000);

                    //privateFunctions.filtersToAirBnB();
                    privateFunctions.calculateOffset();
                    privateFunctions.dataToAirBnB();
                } else {
                    supressMapUpdate = false;
                }

                ajaxRequest = null;

                // do everything for mobile
                if (isAirBnbOrExternalMap && $('#airbnb-buttons').is(':visible')) {
                    followingEementInContainer($('#airbnb-buttons'), $('#search-results-for-sticky-buttons'));
                }

                if (!!callback)
                    callback();
            });
        },
        scrollToModule() {
            //scrolls to the module if, and only if, it was a click back from a detail site
            var currentPage = window.location.href;
            var key = `airBnBKeepPositionOnBack:${currentPage}`;
            //var key2 = `airBnBKeepPosition`;
            var keepPositionOnBack = window.sessionStorage.getItem(key);
            //var keepPosition = window.sessionStorage.getItem(key2);
            if (!!keepPositionOnBack) {
                if (window.pixelpoint.history.visitorCameBack()) {
                    window.sessionStorage.removeItem(key);
                    //window.sessionStorage.removeItem(key2);
                    window.pixelpoint.utilities.scrollTo($(".search-results"), false, 0, true);
                }
            }
        },
        collectFormData(formName) {
            formName = formName || 'poi';
            //collecting form data for tag manager
            var categoryInput = $(".rbnb-wrapper [name='filters[categories][]']");
            var tagInput = $(".rbnb-wrapper select[name='filters[categories][0][tags][]']");
            var locationTreeInput = $(".rbnb-wrapper [name='filters[locationTree][]']");

            var result = {
                "Regionen": null,
                "Orte": null,
                "nationale Naturlandschaften": null,
                "Ausflugsregionen": null,
                "Wassersportreviere": null,
                "Kategorien": null,
                "Unterkunftsarten": null
            };

            var nameMap = {
                'region': 'Regionen',
                'location': 'Orte',
                'aqua': 'Wassersportreviere',
                'national': 'nationale Naturlandschaften',
                'excursion': 'Ausflugsregionen'
            };

            //******* first the categories */
            var selections = null;
            var key = null;
            if (tagInput.length == 0) {
                if (categoryInput.length > 0) {
                    selections = categoryInput.val();
                }
                if (!selections) {
                    var groups = $(".groups-outer-wrapper .groups section[data-group-id]");
                    if (groups.length > 0) {
                        selections = [];
                        groups.each(function () {
                            var categoryInput = $(this).find("input[type='hidden'][name^='filters[categories]']").filter("[name$='[category]']");
                            if (categoryInput.length > 0) {
                                var categoryValue = categoryInput.val();
                                selections.push(categoryValue);
                            }
                        });
                    }
                }

                if (!!selections) {
                    key = 'Kategorien';
                    if (formName == 'accomodation')
                        key = 'Unterkunftsarten';

                    if (!result[key])
                        result[key] = [];

                    $.each(selections, function (i, selection) {
                        var parts = selection.split(":");
                        if (!!parts) {
                            if (parts.length > 1) {
                                result[key].push(parts[1]);
                            } else {
                                result[key].push(parts[0]);
                            }
                        }
                    });
                }
            }
            //**********then the tags */
            selections = null;
            if (tagInput.length > 0) {
                if (tagInput.hasClass("select2-hidden-accessible"))
                    selections = tagInput.select2('data').map(function (x) {
                        return `${x.id}:${x.text}`;
                    });
                else
                    selections = tagInput.val();
            }
            if (!!selections) {
                key = 'Kategorien';
                if (formName == 'accomodation')
                    key = 'Unterkunftsarten';

                if (!result[key])
                    result[key] = [];

                $.each(selections, function (i, selection) {
                    var parts = selection.split(":");
                    if (!!parts) {
                        if (parts.length > 1) {
                            result[key].push(parts[1]);
                        } else {
                            result[key].push(parts[0]);
                        }
                    }
                });
            }

            if (locationTreeInput.length > 0) {
                selections = locationTreeInput.val();
                if (!!selections) {
                    if (!$.isArray(selections))
                        selections = [selections];
                    $.each(selections, function (i, selection) {
                        var parts = selection.split(':');
                        if (parts.length >= 3) {
                            var locationType = nameMap[parts[2]] || null;
                            if (!!locationType) {
                                if (!result[locationType])
                                    result[locationType] = [];
                                result[locationType].push(parts[1]);
                            }
                        }
                    });
                }
            }
            return {
                "Regionen": (result.Regionen != null) ? result.Regionen.join(',') : null,
                "Orte": (result.Orte != null) ? result.Orte.join(',') : null,
                "nationale Naturlandschaften": (result['nationale Naturlandschaften'] != null) ? result['nationale Naturlandschaften'].join(',') : null,
                "Ausflugsregionen": (result.Ausflugsregionen != null) ? result.Ausflugsregionen.join(',') : null,
                "Wassersportreviere": (result.Wassersportreviere != null) ? result.Wassersportreviere.join(',') : null,
                "Kategorien": (result.Kategorien != null) ? result.Kategorien.join(',') : null,
                "Unterkunftsarten": (result.Unterkunftsarten != null) ? result.Unterkunftsarten.join(',') : null,
            };
        },
        checkAndHideExpandButton() {
            $(".filter-form").each((index, filterForm) => {
                let $filterForm = $(filterForm);
                let expandButton = $filterForm.find(".subtitle-aufklapbar");
                let fineFilters = $filterForm.find(".fine-search");
                let collapsed = fineFilters.hasClass("collapsed");
                fineFilters.removeClass("collapsed");
                if (fineFilters.height() == 0) {
                    expandButton.hide();
                } else {
                    expandButton.show();
                }
                if (!!collapsed) {
                    fineFilters.addClass("collapsed");
                    setTimeout(function() {
                        setTabIndexForElements(fineFilters, "-1");
                    }, 100);
                }
                else {
                    setTimeout(function() {
                        setTabIndexForElements(fineFilters, "0");
                    }, 100);
                }
            });
        }
    };
    /**
     * end private functions
     * *******************************************************************************************
     * *******************************************************************************************
     */

    //we load the filters right away
    privateFunctions.loadSessionFilters();

    /**
     * pagination click event
     */
    wrapper.on("click", ".pagination li > a", function (e) {
        e.preventDefault();
        if ($(this).hasClass("disabled")) return;
        supressSliding = false;
        var url = $(this).attr("href");
        form.attr("action", url);

        privateFunctions.submitForm();
    });

    //*****************************************************************************
    //****** TPBB-1035 ************************************************************
    /**
     * click on button "search in area".
     * This button does nothing more than to zoom out.
     */
    wrapper.on("click", ".search-in-area", function (e) {
        e.preventDefault();
        if ($(this).hasClass("disabled")) return;
        var mapObject = mapFunctions.mapObject();
        if (!!mapObject && !!mapObject.zoomOut) {
            //ZP 27.09.2022 - the "search nearby" feature should be treated as a user-map interaction event since it
            //uses the Boundingbox and the user clearly wants to search in a specific area
            mapObject.zoomOut(true, true);
        }
    });
    //*****************************************************************************

    //the search via button is a separate function since we use it on multiple locations
    var triggerSearch = function (supressChangeSection, allowAutomaticSliding) {
        $("[name='filters[productcode][]']").each(function () {
            if (!$(this).is('[data-preserve]'))
                $(this).remove();
        });

        var searchInsideList = $("[name='searchInsideList']");
        if (searchInsideList.length > 0) {
            searchInsideList = searchInsideList.val() == "1";
        } else {
            searchInsideList = false;
        }
        if (!searchInsideList) {
            $("[name='filters[external_id][]']").each(function () {
                $(this).remove();
            });
        }
        //*/

        $("[name='filters[related_to]']").remove();

        if ($(".bis").length > 0) {
            if ($(".bis").is(":disabled") || $(".bis").val() == "") {
                $("[data-input-name='filters[price]']").closest(".control").parent().addClass("hide").prop("disabled", true);
                if ($("[data-input-name='filters[price]']").length > 0) {
                    $("[name='filters[q]']").closest(".control").parent().removeClass("hide").prop("disabled", false);
                }
            } else {
                $("[data-input-name='filters[price]']").closest(".control").parent().removeClass("hide").prop("disabled", false);
                if ($("[data-input-name='filters[price]']").length > 0) {
                    $("[name='filters[q]']").closest(".control").parent().addClass("hide").prop("disabled", true);
                }
            }
        }

        var q = wrapper.find("input[name='filters[q]']").val();
        if (!!q) {
            privateFunctions.clearDefaultTextValue();
        } else {
            privateFunctions.restoreDefaultValue();
        }

        //************** trigger tag manager event *********************** */
        var event = "AirBnB:daten";
        var formName = filtersContainer.find(".brandenbutton.search-button").closest("form[name='search']").data("form-name");
        var data = privateFunctions.collectFormData(formName);
        window.pixelpoint.tagManager.event(event, data);

        var calendar = form.find(".calendar");
        if (calendar.length > 0) {
            var dataExposed = calendar.data("exposed");
            if (!!dataExposed && !!dataExposed.activate) {
                dataExposed.activate();
            }
        }

        supressSliding = !allowAutomaticSliding;
        if (!supressChangeSection)
            changeMapSection = true;
        form.attr("action", "");
        form.submit();
    };

    /***
     * on search button click.
     */
    filtersContainer.on("click", ".brandenbutton.search-button", function (e) {
        e.preventDefault();
        var currentSizeValue = $(".show-map-wrapper .switch-to-map").data('selected-value') || switchToMap.data('initial-value');
        var isMapHidden = currentSizeValue == "big";

        form.find("input[name='filters[additional_external_id][]']").not(".keep").remove();

        var supressChangeSection = true;
        var data = form.serializeArray();

        var usedLocations = [];
        $.each(data, function (index, element) {
            if (element.name == 'filters[locationTree][]' || element.name == 'filters[districts][]') {
                let splitted = element.value.split(":");
                usedLocations.push(splitted[0]);
            }
        });

        var mapObject = mapFunctions.mapObject();
        if (usedLocations.length == 0) {
            //we have no locations
            // ZP 23.12.2021: we check the window width so that the bounding box does not mess up the result count
            if (!!mapObject && !isMapHidden && $(window).width() >= 960)
                boundingBox = mapFunctions.getBBox();//mapObject.bbox(true);
            else {
                supressChangeSection = false;
                boundingBox = null;
            }
        } else if (lastUsedLocations.length > 0 && usedLocations.sort().join(",") == lastUsedLocations.sort().join(",")) {
            //we have the same locations as before
            if (!!mapObject && !isMapHidden)
                boundingBox = mapFunctions.getBBox();//mapObject.bbox(true);
            else {
                supressChangeSection = false;
                boundingBox = null;
            }
        } else {
            supressChangeSection = false;
            boundingBox = null;
            //ZP 08.09.2022 - check variable definition for detailed description
            lockedAfterUserInteraction = false;
        }
        if ($(".brandenbutton.search-button").data("ignore-bbox") == 1) {
            boundingBox = null;
            supressChangeSection = false;
            $(".brandenbutton.search-button").removeData("ignore-bbox").removeAttr("data-ignore-bbox");
        }
        lastUsedLocations = usedLocations;
        triggerSearch(supressChangeSection, true);
    });

    /***
     * subscribing to an event, that only gets triggered if the bullseye icon next to the location input gets clicked
     * it gets triggered if the browser can successfully determine the user location
     */
    window.pixelpoint.pubSub.subscribe(window.pixelpoint.pubSub.events.airBnBSearch, function () {
        triggerSearch();
    });

    /***
     * the submit event. We handle the submit of the form manually.
     */
    form.submit(function (e) {
        e.preventDefault();
        if (privateFunctions.validateForm(true)) {
            //if we have a soft search and the location has not changed we keep the bounding
            //box (ZP 22.12.2022, TPBB-1143, comment from 6. Dezember 2022)
            //debugger
            let isSoftSearchAndLocationChanged = $("[data-soft-search]").data("soft-search") == 1;
            if(isSoftSearchAndLocationChanged){
                const locationValue = $("select.locationTree").val();
                if(
                    !locationValue &&
                    !!$("select.locationTree").data('soft-search-last-location')
                ){
                    //the location did not change
                    isSoftSearchAndLocationChanged = true;
                } else {
                    isSoftSearchAndLocationChanged = false;
                }
            }
            privateFunctions.submitForm(null, false, isSoftSearchAndLocationChanged);
        }
    });

    /***
     * if any form input data has been changed we change the text of the submit button
     */
    $('body').on("change", ".filter-form :input", function () {
        $(this).closest("form").find(".main-filters >.row >.float-right button.search-button").html(window.ppt.translate("button.now.searchagain", "Erneut suchen!"));
    });

    /***
     * after everything has been loaded we make magic.
     * this is the part of the code that prevents us to have an effective asynchronous load. Maybe we can do
     * something about this some day
     */
    var onWindowLoaded = function () {
        /***
         *  do everything for mobile
         */
        if (isAirBnbOrExternalMap && $('#airbnb-buttons').is(':visible')) {
            followingEementInContainer($('#airbnb-buttons'), $('#search-results-for-sticky-buttons'));
            privateFunctions.switchToDefaultView();

            if ($('.toMap', $('#airbnb-buttons')).is(":visible")) {
                if ($("#search-wrapper-id > .map-parent-container").length) {
                    $("#search-wrapper-id > .map-parent-container")
                        .removeClass('map-is-visible map-is-hidden').addClass('map-is-hidden');
                }
                $("#rbnb-wrapper-id .map-container .map-wrapper")
                    .removeClass('map-is-visible map-is-hidden').addClass('map-is-hidden');
            } else {
                if ($("#search-wrapper-id > .map-parent-container").length) {
                    $("#search-wrapper-id > .map-parent-container")
                        .removeClass('map-is-visible map-is-hidden').addClass('map-is-visible');
                }
                $("#rbnb-wrapper-id .map-container .map-wrapper")
                    .removeClass('map-is-visible map-is-hidden').addClass('map-is-visible');
            }

            $('body').on("click", "#changeView", function () {
                changeAirBnbView($(this), false);
            });
            $('body').on("click", "#toFilter", function () {
                scrollToFilter();
            });
        }

        /***
         * after the map has been loaded
         */
        mapLoadedDefer.done(function () {

            /**
             * if we have a predefined region we set the map to that region
             */
            //TODO

            /***
             * we set the initial bbox. If none has been set we reload the module anyways.
             * If the rrequest was a GET request we literally reload the module.
             * if the request was a POST request we submit the form again
             */
            privateFunctions.initialSetBBox(true);


            var map = mapFunctions.mapObject();

            /***
             * only if we have a map object (airbnb)
             */
            if (!!map) {

                /***
                 * common code wrapped in a function so we can use it multiple times below
                 */
                var onSearchTriggered = function (data) {
                    //a small hack to make debugging easier
                    if (!!window.forDebugging)
                        return;

                    //if we do not have a bbox we do not ignore the airbnb event
                    //if (!data.bbox) {
                    //    ignoreAirBnBEvent = false;
                    //    return;
                    //}

                    if (!!moveEndTimeout) {
                        clearTimeout(moveEndTimeout);
                    }
                    moveEndTimeout = setTimeout(function () {
                        if (!!ignoreAirBnBEvent) {
                            ignoreAirBnBEvent = false;
                            return;
                        }

                        const isSoftSearch = $("[data-soft-search]").data("soft-search") == 1;

                        if (isSoftSearch) {
                            $("select.locationTree")
                                .data('soft-search-last-location',$("select.locationTree").val())
                                .val("");//.trigger("change"); // we need the location to still be displayed
                        }
                        /*
                        Slack Change 28.06.2022:
                                if the map is hidden we have to ignore the boundingbox!
                        */
                        if (wrapper.find(".search-wrapper.hiddenMap").length > 0) {
                            mapFunctions.removeBBox();
                        } else {
                            boundingBox = mapFunctions.changeBBox(data.bbox);
                        }
                        //ZP 05.09.2022 - we need the softsearch parameter. If softsearch is enabled we still need the boundingbox.
                        // right now we only use it here since this is the point where a map movement may trigger
                        // a search and thus this is the only? place where soft-search is relevant. Other calls refer to manual search and simmilar. There we avoid the boundingbox
                        // even if soft-search is anabled.
                        privateFunctions.submitForm(null, !!data.isUserInteractionEvent, !!isSoftSearch);
                    }, 300);
                }

                //*
                map.$on("moveend", function (data) {
                    if (mapFunctions.isSearchOnMoveActive() && !mapFunctions.isSearchSupressed()) {
                        //ZP 12.05.2020:
                        // we set the page to 1 to avoid misleading results. If you move the map
                        // or zoom in you get less results. If you are on the last page you get "no results"
                        // which is misleading
                        form.attr(
                            "action",
                            privateFunctions.removePageParameter(form.attr("action"))
                        );
                        // end

                        // ZP 18.05.2020 - TPBB-1069(not part of ticket, problem was just referenced here):
                        // if map was moved we can not move the map again when we send the results to the map
                        mapFunctions.mapObject().fixMapPosition = true;
                        setTimeout(() => {
                            mapFunctions.mapObject().fixMapPosition = false;
                        }, 5000);
                        onSearchTriggered(data);
                    }
                });
                map.$on("searchtrigerred", function (data) {
                    onSearchTriggered(data);
                });
                //*/
                map.$on("highlightover", function (data) {
                    if (!!window.forDebugging)
                        return;

                    if (!$('#airbnb-buttons').is(':visible')) {
                        var id = data.id || 0;
                        var item = $(`.search-result-item[data-id='${id}']`);
                        item.addClass("map-hover");
                    }
                });
                map.$on("highlightout", function (data) {
                    if (!!window.forDebugging)
                        return;
                    $(".search-result-item").removeClass("map-hover");
                });
                wrapper.find(".search").on("mouseover", ".search-result-item", function () {
                    var id = $(this).data("id");
                    if (!id) {
                        return;
                    }
                    mapFunctions.mapObject().focusItem(id);
                    if (!!mapFunctions.mapObject().focusTour)
                        mapFunctions.mapObject().focusTour(id);
                });
                wrapper.find(".search").on("mouseout", ".search-result-item", function () {
                    var id = $(this).data("id");
                    if (!id) {
                        return;
                    }
                    if (!!mapFunctions.mapObject().unfocusTour)
                        mapFunctions.mapObject().unfocusTour(id);
                });
            }
        });
        setTimeout(function () {
            privateFunctions.scrollToModule();
        }, 250);
        var map = mapFunctions.mapObject();
        if (!!map) {
            //privateFunctions.filtersToAirBnB();
            privateFunctions.calculateOffset();
            privateFunctions.dataToAirBnB();
            mapLoadedDefer.resolve();
        } else {
            var switchToMap = $(".show-map-wrapper .switch-to-map");
            var currentValue = switchToMap.data('selected-value') || switchToMap.data('initial-value');
            if (switchToMap.length == 0 || currentValue == 'small') {
                window.pixelpoint.map.scriptsLoaded(function () {
                    if (typeof Vue !== 'undefined') {
                        window.ppcartoAirbnb = new Vue({
                            el: '#ppcarto-airbnb'
                        });
                    }

                    let interval1 = setInterval(() => {
                        let mapObject = mapFunctions.mapObject();
                        if (!!mapObject) {
                            clearInterval(interval1);
                            privateFunctions.calculateOffset();
                            privateFunctions.dataToAirBnB();
                            mapLoadedDefer.resolve();
                        }
                    }, 200);
                });

            } else {
                //switchToMap.one("click", function () {
                $(document).ready(() => {
                    let componentReadyInterval = setInterval(() => {
                        // Check if Vue is defined before accessing its properties
                        if (typeof Vue !== 'undefined' && Vue.options && Vue.options.components) {
                            let componentExists = 'ppcarto-airbnb' in Vue.options.components;
                            if (componentExists) {
                                clearInterval(componentReadyInterval);
                                window.ppcartoAirbnb = new Vue({
                                    el: '#ppcarto-airbnb'
                                });
                            }
                        }
                    }, 200);
                });

                let interval2 = setInterval(() => {
                    let mapObject = mapFunctions.mapObject();
                    if (!!mapObject) {
                        clearInterval(interval2);
                        privateFunctions.calculateOffset();
                        privateFunctions.dataToAirBnB();
                        mapLoadedDefer.resolve();
                    }
                }, 200);

                //});

                $('#airbnb-buttons').one("click", function () {
                    switchToMap.click();
                });
            }
        }

        var switchToMap = $(".show-map-wrapper .switch-to-map");
        var curValue = switchToMap.data('selected-value') || switchToMap.data('initial-value');
        if (switchToMap.length == 0 || curValue == 'big') {
            switchToMap.one("click", function () {
                setTimeout(function () {
                    //privateFunctions.filtersToAirBnB();
                    privateFunctions.calculateOffset();
                }, 200);
            });
        }

        //****** we hide the expand button if necessary */
        privateFunctions.checkAndHideExpandButton();
        //********************************************* */
        privateFunctions.populateMissingElements();
    };

    if (document.readyState === "complete") {
        onWindowLoaded();
    } else {
        $(window).on("load", onWindowLoaded);
    }
    $(window).on("orientationchange resize", function () {
        if (!!window.forDebugging) {
            return;
        }
        if (isAirBnB) {
            privateFunctions.calculateOffset();
        }

        // do everything for mobile
        if (isAirBnbOrExternalMap && $('#airbnb-buttons').is(':visible')) {
            followingEementInContainer($('#airbnb-buttons'), $('#search-results-for-sticky-buttons'));
            privateFunctions.switchToDefaultView();
        }
        privateFunctions.setResultItemHeight();
    });

    wrapper.on("click", ".einklappen.row-collapse", function () {
        $('.map-wrapper.sticky').foundation('_calc', true);
    });
    window.pixelpoint.pubSub.subscribe(window.pixelpoint.pubSub.events.toggleCloseAfter, function () {
        $('.map-wrapper.sticky').foundation('_calc', true);
    });

    //small tag manager snippet******************
    wrapper.on("click", function (e) {
        var event = "AirBnB:click";
        var data = {
            clickOnMap: false,
            AirBnBFilterClick: false
        };
        var target = $(e.target);
        if (target.closest(".search-wrapper .search").length == 0) {
            data.clickOnMap = true;
        }
        if (target.closest("form[name='search']").length > 0) {
            data.AirBnBFilterClick = target.closest("form[name='search']").data("form-name") || true;
        }
        window.pixelpoint.tagManager.event(event, data);
    });

    //some navigational stuff
    wrapper.on("click", ".search-result-item a", function (e) {
        if (!!window.sessionStorage) {
            var currentPage = window.location.href;
            window.sessionStorage.setItem(`airBnBKeepPositionOnBack:${currentPage}`, 1);
            window.sessionStorage.setItem(`comesFromAirBnB`, moment().unix());
        }
    });
    window.pixelpoint.searchform.showHideTourLength();
});


function initStickyAirBnBelements() {
    var marginInPx = $('.header-wrapper .header').height();

    // scroll effect on Large Screens
    if (Foundation.MediaQuery.current == "large") {
        var marginInPxNew = $('.header-wrapper .header .main-nav').height() - 2;
        marginInPx = marginInPxNew;
    }
    // scroll effect on Large Screens - END

    var marginInEm = marginInPx / parseFloat($("body").css("font-size"));

    var moduleId = "#rbnb-wrapper-id";

    if ($("#external-map-wrapper-id").length) {
        moduleId = "#external-map-wrapper-id";
    }

    $(moduleId + ' .sticky').attr('data-margin-top', marginInEm).data('margin-top', marginInEm);

    if ($(moduleId + ' .sticky').attr('data-sticky')) {
        $('.map-wrapper.sticky').foundation('_calc', true);
    } else {
        $(moduleId + ' .sticky').attr('data-sticky', 'true').foundation();
    }

    var ieSearchWrapperHeight = $(window).height() - marginInPx;
    $(".internet-explorer .external-map-wrapper .search-wrapper, .internet-explorer .global-search .search-wrapper, .internet-explorer .rbnb-wrapper .search-wrapper").css("max-height", ieSearchWrapperHeight + "px");
}


var intervalFollingElementInContainer = setInterval(function () {
}, 100);

function followingEementInContainer($elem, $container) {
    clearInterval(intervalFollingElementInContainer);

    var $window = $(window);
    var scrolled = false;
    $window.scroll(function () {
        scrolled = true;
    });

    intervalFollingElementInContainer = setInterval(function () {
        if (scrolled) {
            var containerTop = $container.offset().top;
            var containerBottom = containerTop + $container.outerHeight();
            var viewportTop = $window.scrollTop();
            var viewportBottom = viewportTop + $window.height();

            if (containerTop < viewportBottom && viewportBottom < containerBottom) {
                $elem.css({
                    opacity: 1,
                    position: 'fixed',
                    bottom: 0
                });
            } else {
                $elem.css({
                    opacity: 1,
                    position: 'absolute',
                    bottom: 0
                });

            }
            scrolled = false;
        }
    }, 100);
}

function changeAirBnbView($this, scrollToFilter) {
    var shownButtonTextClass = '.toMap';
    var hiddenButtonTextClass = '.toList';
    var mapZindex = 10;
    var resultsZindex = 100;
    let mobileDisplayClass = 'map-is-hidden';
    var resultsMaxHeight = 'none';
    var $followElem = $('#search-results-for-sticky-buttons');
    var airBnbWrapperHeight = 'auto';
    var $buttonFollowingElem = $('#search-results-for-sticky-buttons');
    var moduleId = "#rbnb-wrapper-id";

    if ($("#external-map-wrapper-id").length) {
        moduleId = "#external-map-wrapper-id";
    }

    if ($('.toMap', $this).is(":visible")) {
        shownButtonTextClass = '.toList';
        hiddenButtonTextClass = '.toMap';
        mobileDisplayClass = 'map-is-visible';
        mapZindex = 101;
        resultsZindex = 10;
        resultsMaxHeight = $(moduleId + " .map-container .map-wrapper").height() + 'px';
        $followElem = $(moduleId + ' .map-container .map-wrapper');
        airBnbWrapperHeight = resultsMaxHeight;
        $buttonFollowingElem = $('#search-wrapper-id');
    } else {
    }

    $(hiddenButtonTextClass, $this).hide();
    $(shownButtonTextClass, $this).show();

    if ($("#search-wrapper-id > .map-parent-container").length) {
        $("#search-wrapper-id > .map-parent-container").css('z-index', mapZindex)
            .removeClass('map-is-visible map-is-hidden').addClass(mobileDisplayClass);
    }
    $("#rbnb-wrapper-id .map-container .map-wrapper").css('z-index', mapZindex)
        .removeClass('map-is-visible map-is-hidden').addClass(mobileDisplayClass);
    $("#search-wrapper-id > .search").css({
        'z-index': resultsZindex,
        'max-height': resultsMaxHeight
    });
    $('#rbnb-wrapper-id').height(airBnbWrapperHeight);
    $this.removeClass("ui-btn-active");
    followingEementInContainer($('#airbnb-buttons'), $buttonFollowingElem);

    if (scrollToFilter) {
        setTimeout(() => {
            $("html, body").animate({
                scrollTop: $("#search-wrapper-id").offset().top - $('.header-wrapper .header').height()
            }, 800);
        }, 200)

    } else {
        setTimeout(() => {
            $("html, body").animate({
                scrollTop: $followElem.offset().top - $('.header-wrapper .header').height()
            }, 800);
        }, 200);
    }
}

function scrollToFilter() {
    if ($('#changeView .toMap').is(":visible")) {
        $("html, body").animate({
            scrollTop: $("#search-wrapper-id").offset().top - $('.header-wrapper .header').height()
        }, 800);
    } else if ($('#changeView .toList').is(":visible")) {
        changeAirBnbView($('#changeView'), true);
    }
}